// @react/hooks/useNotificationsContact.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { notificationsContactStore } from '@core/stores';

/**
 * React hook for Contact operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useNotificationsContact } from '@react/hooks';
 *
 * const ContactList = observer(() => {
 *   const store = useNotificationsContact();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useNotificationsContact() {
  return notificationsContactStore;
}
